import { call, put, select, takeEvery } from "redux-saga/effects";
import { api } from "Shared/axios";

import { countryListActions } from "./country_list.slice";
import { selectCountryList } from "./contry_list.select";

function* fetchCountryListWorker() {
	const countryList = yield select(selectCountryList.list);
	if (countryList.length) return;
	let allData = [];
	try {
		while (allData.length === 0 || allData % 100 === 0) {
			const params = {
				offset: allData.length,
				limit: 100,
			};
			const { data } = yield call(api.get, "/country", params);

			// Добавляем новые данные в массив
			allData.push(...data);
		}
	} catch (error) {
		console.error("fetchCountryListWorker Error: ", error);
	} finally {
		// Отправляем все собранные данные в хранилище
		yield put(countryListActions.set(allData));
	}
}

export function* watchCountryList() {
	yield takeEvery(countryListActions.get, fetchCountryListWorker);
}
